export default {
  '3D Rotate': 'Xoay 3D',
  'API Key': 'API Key',
  'Academic Rank': 'Học hàm',
  'Academic Rank/Degree': 'Học hàm/Học vị',
  'Account List': 'Danh sách tài khoản',
  'Guest Account List': 'Danh sách tài khoản khách',
  'Add Guest Account': 'Thêm tài khoản khách',
  'Acquisition Time (s)': 'Thời gian nhận (s)',
  'Active viewport has no displayed image':
    'Không có hình ảnh trong khung hình',
  'Add Account': 'Thêm tài khoản',
  'Add Device': 'Thêm thiết bị',
  'Add Filter Condition': 'Thêm điều kiện lọc',
  'Add Filter': 'Thêm bộ lọc',
  'Add Group Account': 'Thêm nhóm tài khoản',
  'Add Institution': 'Thêm cơ sở',
  'Add Facility': 'Thêm cơ sở',
  'Add Layout Report': 'Thêm mẫu in báo cáo',
  'Add Order': 'Thêm chỉ định',
  'Add Procedure Group': 'Thêm nhóm dịch vụ',
  'Add Procedure': 'Thêm dịch vụ',
  'Add Body Part': 'Thêm bộ phận chụp',
  'Edit Body Part': 'Chỉnh sửa bộ phận chụp',
  'Add Department': 'Thêm khoa phòng',
  'Edit Department': 'Chỉnh sửa khoa phòng',
  'Add Role': 'Thêm nhóm quyền',
  'Add Rule CAD': 'Thêm quy tắc CAD',
  'Add Template': 'Thêm mẫu báo cáo',
  'Add User': 'Thêm người dùng',
  'Adjust Window': 'Điều chỉnh cửa sổ',
  'All exam for this patient id': 'Tất cả các xét nghiệm cho mã người bệnh này',
  'All files uploading will be canceled.':
    'Tất cả các tệp đang tải lên sẽ bị hủy',
  'All time': 'Tất cả',
  'All Time': 'Tất cả',
  'Approve Date': 'Thời gian duyệt báo cáo',
  'Approved By': 'Người duyệt báo cáo',
  'Are you sure you want to close?':
    'Các tệp đang tải lên sẽ bị hủy, bạn có muốn đóng đóng cửa sổ?',
  'Are you sure you want to delete share?': 'Bạn có muốn xóa chia sẻ ca chụp?',
  'Arrived At': 'Thời gian đến',
  'Assign Radiologist': 'Chỉ định bác sĩ',
  'Assign Type': 'Loại chỉ định',
  'Assigned At': 'Thời gian được chỉ định',
  'Assigned List': 'Danh sách được chỉ định',
  'Assigned To': 'Chỉ định tới',
  'File Attachment': 'Tệp đính kèm',
  'Auto Send to CAD': 'Tự động gửi tới CAD',
  'Body Part': 'Bộ phận chụp',
  'CAD Not Supported': 'CAD không hỗ trợ',
  'CAD Suggestion': 'Gợi ý của CAD',
  'CAD need more time for diagnosing': 'CAD cần thêm thời gian chẩn đoán',
  'Can not start camera': 'Không thể khởi chạy máy ảnh',
  'Can not stop camera': 'Không thể tắt máy ảnh',
  'Open Camera': 'Mở máy ảnh',
  'Capture Image': 'Chụp hình',
  'Capture Video': 'Mở máy ảnh',
  'Record Video': 'Quay video',
  Attach: 'Đính kèm',
  Fullscreen: 'Toàn màn hình',
  'Change Device': 'Thay đổi thiết bị',
  'Change Password': 'Thay đổi mật khẩu',
  'Change Value DICOM Fields': 'Đổi giá trị các trường DICOM',
  'Choose Report Template': 'Chọn mẫu báo cáo',
  'Clear Filter': 'Xóa bộ lọc',
  'Confirm Password': 'Xác nhận mật khẩu',
  'Create Order': 'Tạo chỉ định',
  'Create RT Report': 'Tạo báo cáo RT',
  'Create Report': 'Tạo báo cáo',
  'Create error': 'Tạo lỗi',
  'Created At': 'Thời gian tạo',
  'Data List': 'Danh sách dữ liệu',
  'Demographic Info': 'Thông tin bệnh nhân',
  'Device Name': 'Tên thiết bị',
  'Device Type': 'Kiểu thiết bị',
  'Dicom Adapter': 'Bộ chuyển đổi DICOM',
  'Dicom Data': 'Dữ liệu DICOM',
  'Drag and drop files here or': 'Kéo và thả các tệp tại đây hoặc',
  'Edit Account': 'Cập nhật tài khoản',
  'Edit Assign Radiologist': 'Cập nhật chỉ định bác sĩ',
  'Edit Device': 'Cập nhật thiết bị',
  'Edit Filter': 'Cập nhật bộ lọc',
  'Edit Group Account': 'Cập nhật nhóm tài khoản',
  'Edit Institution': 'Cập nhật cơ sở',
  'Edit Facility': 'Cập nhật cơ sở',
  'Edit Layout Report': 'Cập nhật mẫu báo cáo',
  'Edit Order': 'Cập nhật chỉ định',
  'Edit Procedure Group': 'Cập nhật nhóm dịch vụ',
  'Edit Procedure': 'Cập nhật dịch vụ',
  'Edit Report': 'Cập nhật báo cáo',
  'Edit Role': 'Cập nhật nhóm quyền',
  'Edit Rule CAD': 'Cập nhật quy tắc CAD',
  'Edit Template': 'Chỉnh sửa mẫu báo cáo',
  'Enter AETitle': 'Nhập AETitle',
  'Enter API Key': 'Nhập API Key',
  'Enter Academic Rank': 'Nhập học hàm',
  'Enter Academic Rank/Degree': 'Nhập học hàm/học vị',
  'Enter Address': 'Nhập địa chỉ',
  'Enter Age': 'Nhập tuổi',
  'Enter Approver Name': 'Nhập tên người phê duyệt',
  'Enter Birthday': 'Nhập ngày tháng năm sinh',
  'Enter Body Part': 'Nhập bộ phận chụp',
  'Enter Conclusion': 'Nhập kết luận',
  'Enter Content': 'Nhập nội dung',
  'Enter Device Name': 'Nhập tên thiết bị',
  'Enter Diagnoses': 'Nhập chẩn đoán',
  'Enter Email': 'Nhập Email',
  'Enter Expired Date': 'Nhập ngày hết hạn',
  'Enter Filter Name': 'Nhập tên bộ lọc',
  'Enter Full Name': 'Nhập họ và tên',
  'Enter Gender': 'Nhập giới tính',
  'Enter Group Name': 'Nhập tên nhóm',
  'Enter HIS ID': 'Nhập mã HIS',
  'Enter Hostname/IP': 'Nhập tên máy chủ/IP',
  'Enter Institution Name': 'Nhập tên cơ sở',
  'Enter Facility Name': 'Nhập tên cơ sở',
  'Enter Layout Name': 'Nhập tên mẫu',
  'Enter Order Doctor': 'Nhập bác sĩ chỉ định',
  'Enter Order Group': 'Nhập mã chỉ định',
  'Enter Pass Code': 'Nhập mật mã',
  'Enter Password': 'Nhập mật khẩu',
  'Enter Patient ID': 'Nhập mã người bệnh',
  'Enter Patient Name': 'Nhập tên người bệnh',
  'Enter Phone Number': 'Nhập số điện thoại',
  'Enter Procedure Code': 'Nhập mã dịch vụ',
  'Enter Procedure Group Name': 'Nhập tên nhóm dịch vụ',
  'Enter Procedure Name': 'Nhập tên dịch vụ',
  'Enter Department Code': 'Nhập mã khoa phòng',
  'Enter Department Name': 'Nhập tên khoa phòng',
  'Enter Location': 'Nhập địa điểm',
  'Enter Body Part Name': 'Nhập tên bộ phận',
  'Enter Refer Doctor': 'Nhập bác sĩ giới thiệu',
  'Enter Role Code': 'Nhập mã nhóm quyền',
  'Enter Role Name': 'Nhập tên nhóm quyền',
  'Enter Rule Name': 'Nhập tên quy tắc',
  'Enter Source AETitle': 'Nhập nguồn AETitle',
  'Enter Template Code': 'Nhập mã mẫu báo cáo',
  'Enter Template Name': 'Nhập tên mẫu',
  'Enter Type': 'Nhập loại',
  'Enter Username': 'Nhập tên đăng nhập',
  'Enter Visit ID': 'Nhập mã lượt khám',
  'Enter address': 'Nhập địa chỉ',
  'Enter body part': 'Nhập bộ phận chụp',
  'Enter confirm password': 'Nhập xác nhận mật khẩu',
  'Enter description': 'Nhập mô tả',
  'Enter device name': 'Nhập tên thiết bị',
  'Enter in the format': 'Nhập theo định dạng',
  'Enter institution code': 'Nhập mã cơ sở',
  'Enter interval': 'Nhập khoảng thời gian',
  'Enter password': 'Nhập mật khẩu',
  'Enter port': 'Nhập cổng',
  'Enter procedure code': 'Nhập mã dịch vụ',
  'Enter short name': 'Nhập tên viết tắt',
  'Enter username': 'Nhập tên đăng nhập',
  'Error Message': 'Đã xảy ra lỗi, vui lòng thử lại sau',
  'Exam By Radiologist': 'Báo cáo chi tiết theo bác sĩ',
  Exams: 'Danh sách ca chụp',
  'Exam Info': 'Thông tin ca chụp',
  'Expired At': 'Thời gian hết hạn',
  'Expired Date': 'Ngày hết hạn',
  'Export CSV': 'Xuất CSV',
  'FOR INVESTIGATIONAL USE ONLY': 'Chỉ dùng cho nghiên cứu',
  'File Name': 'Tên tập tin',
  'File Type': 'Loại tập tin',
  'Film Size': 'Kích thước film',
  'Film Type': 'Loại film',
  'Filter Management': 'Quản lý bộ lọc',
  'Filter Name': 'Tên bộ lọc',
  'Filter Type': 'Loại bộ lọc',
  'Freehand Scalpel': 'Cắt thủ công',
  'Full Name': 'Họ và tên',
  'Generate Key': 'Tạo API Key',
  'Generate Link': 'Tạo liên kết',
  'Go back Home': 'Về trang chủ',
  'Group Account List': 'Danh sách nhóm tài khoản',
  'Group Account': 'Nhóm tài khoản',
  'Group Name': 'Tên nhóm',
  'HIS ID': 'Mã HIS',
  // 'Half Life (s)': '',
  'Header:About': 'Tiêu đề: giới thiệu',
  'Header:Logout': 'Tiêu đề: Đăng xuất',
  'Header:Preferences': 'Tiêu đề: mục ưu tiên',
  'Hostname/IP': 'Tên máy chủ/IP',
  'INVESTIGATIONAL USE ONLY': 'Chỉ sử dụng nghiên cứu',
  'Image height (px)': 'Chiều cao hình ảnh (px)',
  'Image preview': 'Xem trước hình ảnh',
  'Image width (px)': 'Độ rộng hình ảnh (px)',
  'Import files': 'Nhập các tệp',
  'Injection Time (s)': 'Thời gian tiêm thuốc',
  'Institution Code': 'Mã cơ sở',
  'Facility Code': 'Mã cơ sở',
  'Institution Name': 'Tên cơ sở',
  'Facility Name': 'Tên cơ sở',
  'Interval(s)': 'Khoảng thời gian',
  'Invalid image': 'Ảnh không hợp lệ',
  'Invalid username': 'Tên đăng nhập không hợp lệ',
  'Key Image': 'Ảnh bệnh lý',
  'Last 30 days': '30 ngày gần nhất',
  'Last Month': 'Tháng gần nhất',
  'Layout List': 'Danh sách mẫu',
  'Layout Name': 'Tên mẫu',
  'Layout Report': 'Mẫu in báo cáo',
  'Loading recent report...': 'Đang tải báo cáo gần đây...',
  Match: 'Ghép',
  'Match Order': 'Ghép chỉ định',
  'Basic Report': 'Báo cáo cơ bản',
  'Structured Report': 'Báo cáo có cấu trúc',
  History: 'Lịch sử',
  'Match Status': 'Trạng thái ghép',
  'Medium Type': 'Loại film',
  'Merge Order With Same Patient': 'Gộp chỉ định của cùng một người bệnh',
  'NON-DICOM': 'NON-DICOM',
  'New Report': 'Tạo báo cáo',
  'No Order': 'Không có chỉ định',
  'No layout selected yet': 'Chưa có mẫu nào được chọn',
  'No permission found': 'Không tìm thấy quyền',
  'No selected order': 'Không có chỉ định nào được chọn',
  'No tracked measurements': 'Không có chỉ số nào được theo dõi',
  'No video source': 'Không có nguồn video',
  'Non-dicom Data': 'Dữ liệu Non-dicom',
  'Not strong enough': 'Không đủ mạnh',
  'Number Of Copies': 'Số bản sao',
  'Only Super Admin can add new role':
    'Chỉ quản trị viên cấp cao mới có thể thêm nhóm quyền mới',
  'Only show failed files': 'Chỉ hiển thị các tệp lỗi',
  'Open Report': 'Xem báo cáo',
  'Open Viewer and Report': 'Xem ảnh và báo cáo',
  'Open Viewer': 'Xem ảnh',
  'Open in Split Window and Report': 'Mở trong cửa sổ chia nhỏ và báo cáo',
  'Open in Split Window': 'Mở trong cửa sổ chia nhỏ',
  'Order Date': 'Ngày chỉ định',
  'Order Doctor': 'Bác sĩ chỉ định',
  'Admitting Diagnoses': 'Chẩn đoán lâm sàng',
  'Order Group': 'Mã chỉ định',
  'Order Information': 'Thông tin chỉ định',
  'Order List': 'Danh sách chỉ định',
  'Order Search': 'Tìm kiếm chỉ định',
  'Ordinal Number': 'Số thứ tự',
  'Page Number': 'Số trang',
  'Invalid Pass Code': 'Mã khóa không hợp lệ',
  'Invalid Citizen ID': 'CMND/CCCD không hợp lệ',
  'Pass Code Required': 'Yêu cầu mã',
  'Citizen ID Required': 'Yêu cầu số CMND/CCCD',
  'Password does not match': 'Mật khẩu không khớp',
  'Patient ID': 'Mã người bệnh',
  'Patient Info': 'Thông tin người bệnh',
  'Patient Information': 'Thông tin người bệnh',
  'Patient Name': 'Tên người bệnh',
  'Patient Search': 'Tìm kiếm người bệnh',
  'Patient Sex': 'Giới tính',
  'Patient Weight (kg)': 'Cân nặng',
  'Patient search': 'Tìm kiếm người bệnh',
  'Percentage of Max SUV': '',
  'Performance By Radiologist': 'Hiệu suất làm việc của bác sĩ',
  'Performed Studies': 'Ca đã chụp',
  'Phone Number': 'Số điện thoại',
  'Please allow access to your camera and microphone':
    'Please allow access to your camera and microphone',
  'Please enter a number': 'Vui lòng nhập vào số',
  'Please enter a positive number': 'Vui lòng nhập số dương',
  'Please enter note': 'Vui lòng nhập ghi chú',
  'Please enter password': 'Vui lòng nhập mật khẩu',
  'Print Page Range': 'In từ trang - đến trang',
  'Print Type': 'Kiểu in',
  'Procedure Code': 'Mã dịch vụ',
  'Procedure Group Name': 'Tên nhóm dịch vụ',
  'Procedure Group': 'Nhóm dịch vụ',
  'Procedure Name': 'Tên dịch vụ',
  'Procedure Search': 'Tìm kiếm dịch vụ',
  'Department Code': 'Mã khoa phòng',
  'Department Name': 'Tên khoa phòng',
  'Results Delivery Location': 'Địa điểm nhận kết quả',
  Department_Title: 'Khoa phòng',
  'Body Part Name': 'Tên bộ phận',
  'Processing...': 'Đang xử lý...',
  // 'ROI Threshold Configuration': '',
  'Rectangle Scalpel': 'Cắt hình chữ nhật',
  'Refer Doctor': 'Bác sĩ tham chiếu',
  'Reject latest report': 'Từ chối báo cáo mới nhất',
  'Remove Bed': 'Xóa giường',
  'Report History': 'Lịch sử báo cáo',
  'Report Template': 'Mẫu báo cáo',
  'Required value': 'Thông tin bắt buộc',
  'Reset password': 'Khôi phục mật khẩu',
  'Reset to Defaults': 'Khôi phục mặc định',
  'Role Code': 'Mã nhóm quyền',
  'Role Name': 'Tên nhóm quyền',
  'Rule CAD': 'Quy tắc cho CAD',
  'Rule Name': 'Tên quy tắc',
  'Scheduled Date': 'Ngày lên lịch',
  'Select Academic Rank': 'Chọn học hàm',
  'Select Account': 'Chọn tài khoản',
  'Select Study': 'Chọn dữ liệu',
  'Select Auto Send to CAD': 'Chọn tự động gửi CAD',
  'Select CAD Tool': 'Chọn công cụ CAD',
  'Select Creator': 'Chọn người tạo',
  'Select Date': 'Chọn ngày',
  'Select Device Type': 'Chọn loại thiết bị',
  'Select Device': 'Chọn thiết bị',
  'Select Files': 'Chọn tệp',
  'Select Folder': 'Chọn thư mục',
  'Select Gender': 'Chọn giới tính',
  'Select Group Account': 'Chọn nhóm tài khoản',
  'Select Institution': 'Chọn cơ sở',
  'Select Institutions': 'Chọn cơ sở',
  'Select Facility': 'Chọn cơ sở',
  'Select Facilities': 'Chọn cơ sở',
  'Select Layout List': 'Chọn danh sách mẫu in',
  'Select Match status': 'Chọn trạng thái ghép nối',
  'Select Modality': 'Chọn loại thiết bị',
  'Select Order status': 'Chọn trạng thái chỉ định',
  'Select Procedure Group': 'Chọn nhóm dịch vụ',
  'Select Procedure Name': 'Chọn tên dịch vụ',
  'Select Role': 'Chọn nhóm quyền',
  'Select Roles': 'Chọn nhóm quyền',
  'Select Share By': 'Chọn người chia sẻ',
  'Select Share Type': 'Chọn kiểu chia sẻ',
  'Select Status': 'Chọn trạng thái',
  'Select Studylist status': 'Chọn trạng thái ca chụp',
  'Select Type': 'Chọn kiểu',
  'Select condition': 'Chọn điều kiện',
  'Select date range': 'Chọn khoảng thời gian',
  'Select date': 'Chọn ngày',
  'Select group': 'Chọn nhóm',
  'Select institutions': 'Chọn cơ sở',
  'Select Layout': 'Chọn mẫu in',
  'Select technician': 'Chọn kĩ thuật viên',
  'Select type': 'Chọn kiểu',
  'Selected study only': 'Ca chụp',
  'Share By': 'Người chia sẻ',
  'Share Link': 'Link chia sẻ',
  'Share Settings': 'Thiết lập chia sẻ',
  'Share Study': 'Chia sẻ ca chụp',
  'Share Type': 'Phạm vi chia sẻ',
  'Shared Date': 'Ngày chia sẻ',
  'Shared List': 'Danh sách chia sẻ',
  'Short Name': 'Tên viết tắt',
  'Show Annotations': 'Kèm theo chú giải',
  'Some files are not supported. Do you want to continue?':
    'Một số tệp không được hỗ trợ. Bạn có muốn tiếp tục?',
  'Split Window': 'Chia đôi màn hình',
  'Split Windows': 'Chia đôi màn hình',
  'Study Date': 'Ngày chụp',
  'Study Description': 'Mô tả ca chụp',
  'Study Information': 'Thông tin ca chụp',
  'Study Share': 'Chia sẻ ca chụp',
  'Submitted By': 'Người lưu báo cáo',
  'Template Code': 'Mã mẫu báo cáo',
  'Template Name': 'Tên mẫu',
  'Template Report': 'Mẫu báo cáo',
  'Text Size': 'Cỡ chữ',
  'This Month': 'Tháng này',
  Yesterday: 'Hôm qua',
  'Last 7 days': '7 ngày gần nhất',
  'This Year': 'Năm nay',
  'Last Year': 'Năm trước',
  'This template will overwrite your current work?':
    'Mẫu báo cáo này sẽ ghi đè nội dung hiện tại. Bạn có muốn tiếp tục?',
  // 'Total Dose (bq)': '',
  'Unavailable CAD': 'CAD chưa hỗ trợ',
  'Update AI result': 'Cập nhật kết quả AI',
  'Update Profile': 'Cập nhật thông tin',
  'Updated At': 'Thời gian cập nhật',
  'Upload Logo': 'Tải lên Logo',
  'Upload Signature': 'Tải lên chữ ký',
  'Upload file success': 'Tải tệp lên thành công',
  'Upload files': 'Tải lên danh sách tệp',
  'Upload image failed': 'Không tải được hình ảnh lên',
  'User List': 'Danh sách người dùng',
  'User Settings': 'Thiết lập người dùng',
  'UserPreferencesModal:User Preferences': 'Tùy chọn người dùng',
  'Username must be at least 4 characters':
    'Tên đăng nhập phải nhiều hơn 4 ký tự',
  'Username must be less than 50 characters':
    'Tên đăng nhập phải ít hơn 50 ký tự',
  'Username or Email': 'Tên đăng nhập hoặc email',
  'Visit ID mismatch': 'Mã lượt khám không khớp',
  'Visit ID': 'Mã lượt khám',
  'You need to match study with order or create new order':
    'Bạn cần ghép ca chụp với chỉ định hoặc tạo chỉ định mới',
  // 'Đăng ký gói MAX': '',
  AETitle: 'AETitle',
  APPROVED: 'ĐÃ DUYỆT',
  ARRIVED: 'ĐÃ ĐẾN',
  Abnormal: 'Có bất thường',
  Access: 'Phạm vi truy cập',
  Account: 'Tài khoản',
  Action: 'Thao tác',
  Actions: 'Thao tác',
  Active: 'Đang hoạt động',
  Add: 'Thêm',
  Address: 'Địa chỉ',
  Administration: 'Quản trị',
  Age: 'Tuổi',
  All: 'Tất cả',
  Apply: 'Áp dụng',
  Approve: 'Phê duyệt',
  Approved: 'Đã duyệt',
  Approver: 'Người phê duyệt',
  Updater: 'Người cập nhật',
  Arrived: 'Đã đến',
  Assign: 'Chỉ định',
  Assigned: 'Đã chỉ định',
  Back: 'Quay lại',
  Birthday: 'Ngày sinh',
  Bookmark: 'Đánh dấu',
  Border: 'Đường viền',
  CAD: 'CAD',
  CANCEL: 'HỦY',
  COMPLETED: 'ĐÃ THỰC HIỆN',
  Camera: 'Máy ảnh',
  Cancel: 'Hủy',
  Capture: 'Chụp hình',
  Clear: 'Xóa',
  ClearFilters: 'Xóa bộ lọc',
  Close: 'Đóng',
  Column: 'Cột',
  Completed: 'Đã thực hiện',
  Conclusion: 'Kết luận',
  Condition: 'Điều kiện',
  Confirm: 'Xác nhận',
  Connection: 'Kết nối',
  Content: 'Nội dung',
  Creator: 'Người tạo',
  Crosshairs: 'Vị trí tương quan',
  Custom: 'Tùy biến',
  DICOM: 'DICOM',
  Dashboard: 'Thống kê',
  Delete: 'Xóa',
  Description: 'Mô tả',
  // Destination: 'Điểm đến',
  Device: 'Thiết bị',
  Devices: 'Thiết bị',
  Diagnoses: 'Chẩn đoán',
  Diagnostic: 'Chẩn đoán',
  Download: 'Tải xuống',
  Edit: 'Sửa',
  Email: 'Email',
  Empty: 'Nền',
  End: 'Đến',
  Export: 'Xuất Tệp',
  Female: 'Nữ',
  Finish: 'Hoàn thành',
  Forbidden: 'Bị cấm',
  Function: 'Chức năng',
  Gender: 'Giới tính',
  General: 'Tổng quát',
  Group: 'Nhóm',
  Help: 'Trợ giúp',
  High: 'Cao',
  Hotkeys: 'Phím tắt',
  Import: 'Thêm',
  Inactive: 'Không hoạt động',
  Information: 'Thông tin',
  Institution: 'Cơ sở',
  Facility: 'Cơ sở',
  Institutions: 'Cơ sở',
  Facilities: 'Cơ sở',
  Keyword: 'Từ khóa',
  LOAD: 'Tải',
  LOGIN: 'Đăng nhập',
  Language: 'Ngôn ngữ',
  Length: 'Thước đo',
  Loading: 'Đang tải',
  Login: 'Đăng nhập',
  Logout: 'Đăng xuất',
  MRN: 'MRN',
  Magnification: 'Độ phóng đại',
  Male: 'Nam',
  Matched: 'Đã thực hiện',
  Max: 'Tối đa',
  Microphone: 'Microphone',
  Min: 'Tối thiểu',
  Modality: 'Loại thiết bị',
  NEW: 'MỚI',
  New: 'Mới',
  Next: 'Tiếp theo',
  No: 'Không',
  Normal: 'Không thấy bất thường',
  Note: 'Ghi chú',
  // NumOfStudiesHiggerThan100Message: '',
  OK: 'Đồng ý',
  Open: 'Mở',
  Order: 'Chỉ định',
  Orders: 'Chỉ định',
  Orientation: 'Bố trí',
  Other: 'Khác',
  Overview: 'Tổng quan',
  Page: 'Trang',
  Paper: 'Giấy',
  Password: 'Mật khẩu',
  Patient: 'Người bệnh',
  Pending: 'Đang chờ',
  Permissions: 'Quyền',
  Phone: 'Số điện thoại',
  Port: 'Cổng',
  Preferences: 'Tùy chọn',
  Preview: 'Xem trước',
  // Previous: 'Trước đó',
  Print: 'In',
  Priority: 'Mức độ ưu tiên',
  'Change Status': 'Đổi trạng thái',
  Private: 'Cá nhân',
  Procedure: 'Dịch vụ',
  Processed: 'Đã xử lý',
  Profile: 'Thông tin cá nhân',
  Public: 'Công khai',
  Quality: 'Chất lượng',
  Quantity: 'Số lượng',
  READING: 'ĐANG ĐỌC',
  Reading: 'Đang đọc',
  Receive: 'Tiếp nhận',
  Reception: 'Tiếp đón',
  Report: 'Báo cáo',
  Reset: 'Đặt lại',
  Resolution: 'Độ phân giải',
  // ResultsPerPage: '',
  Retry: 'Thử lại',
  Role: 'Nhóm quyền',
  Roles: 'Nhóm quyền',
  Save: 'Lưu',
  Create: 'Tạo',
  Saving: 'Đang lưu',
  Scanner: 'Máy quét',
  Search: 'Tìm kiếm',
  // Segmentations: '',
  Select: 'Lựa chọn',
  Settings: 'Thiết lập',
  Sex: 'Giới tính',
  Share: 'Đã chia sẻ',
  ShareSettings: 'Thiết lập chia sẻ',
  Shortcut: 'Phím tắt',
  Signature: 'Chữ ký',
  Sorry: 'Xin lỗi',
  Spacing: 'Khoảng cách',
  Start: 'Bắt đầu',
  Status: 'Trạng thái',
  // Strategy: '',
  Studies: 'Danh sách ca chụp',
  StudyList: 'Danh sách ca chụp',
  Studylist: 'Danh sách ca chụp',
  Submit: 'Gửi',
  Technician: 'Kỹ thuật viên',
  // Thickness: '',
  Today: 'Hôm nay',
  Total: 'Tổng',
  Trim: 'Cắt',
  Type: 'Kiểu',
  Unmatched: 'Chưa ghép chỉ định',
  Upload: 'Tải lên',
  User: 'Người dùng',
  Username: 'Tên đăng nhập',
  Value: 'Giá trị',
  Warning: 'Cảnh báo',
  Worklist: 'Danh sách công việc',
  Yes: 'Đồng ý',
  browse: 'duyệt',
  columns: 'Cột',
  failed: 'thất bại',
  items: 'dòng',
  more: 'Hiển thị thêm',
  success: 'thành công',
  to: 'Đến',
  Expand: 'Mở rộng',
  Collapse: 'Thu gọn',
  'No Data': 'Không có dữ liệu',
  'No notes': 'Chưa có ghi chú',
  'Add new note': 'Thêm mới ghi chú',
  NO: 'STT',
  Sharing: 'Chia sẻ',
  Shared: 'Đã chia sẻ',
  Expired: 'Hết hạn',
  'Source AETitle': 'Nguồn AETitle',
  'Studylist Status': 'Trạng thái ca chụp',
  'Order Status': 'Trạng thái chỉ định',
  'All devices': 'Tất cả thiết bị',
  Unknown: 'Không xác định',
  Default: 'Mặc định',
  'My Templates': 'Mẫu của tôi',
  Guest: 'Khách',
  'Invalid phone number': 'số điện thoại không hợp lệ',
  'At least 10 numbers': 'Hãy điền ít nhất 10 số',
  'Please fill in number': 'Vui lòng chỉ điền số',
  'CAD|Yes': 'Có',
  Layout: 'Mẫu in báo cáo',
  Study: 'Ca chụp',
  Template: 'Mẫu báo cáo',
  Viewer: 'Xem ảnh',
  'Are you sure to delete dicom study?':
    'Bạn có chắc chắn muốn xóa ca chụp dicom?',
  'Are you sure delete this annotation?':
    'Bạn có chắc chắn muốn xóa chú thích này?',
  'Are you sure delete all annotations on this instance?':
    'Bạn có chắc chắn muốn xóa tất cả chú thích cho ảnh này?',
  "You don't have permission to access this page.":
    'Bạn không có quyền truy cập trang này.',
  'Upload Files': 'Tải tệp lên',
  'file(s)': 'tệp',

  "It's time to upgrade": 'THÔNG BÁO MUA GÓI',
  'You have reached the limit of your current plan': 'Quý khách đã sử dụng hết',
  '10 links per month': '10 lượt chia sẻ công khai / tháng',
  'Please register MAX package to continue using this feature':
    'Vui lòng đăng ký gói MAX để tiếp tục sử dụng tính năng này.',
  'Thank you!': 'Xin cảm ơn!',
  'Register now': 'Đăng ký gói MAX',
  'Dashboard Order': 'Thống kê chỉ định',
  'Order By Modality': 'Chỉ định theo loại thiết bị',
  'Top 5 Of Approver': 'Top 5 người phê duyệt',
  'Top 5 Of Procedure': 'Top 5 dịch vụ',
  'Close Camera': 'Đóng máy ảnh',
  'HIS Order List': 'Danh sách chỉ định HIS',
  'Enter PID': 'Nhập mã người bệnh',
  'Patient Visit List': 'Danh sách lượt khám',
  'Add HIS Order': 'Thêm chỉ định HIS',
  PID: 'Mã người bệnh',
  Department: 'Khoa thực hiện',
  'Order Department': 'Khoa chỉ định',
  'Procedure Date': 'Ngày chụp',
  'Enter Procedure Date': 'Nhập ngày chụp',
  'Ender Order': 'Nhập chỉ định',
  'Enter Note': 'Nhập ghi chú',
  'Enter Department': 'Nhập khoa thực hiện',
  'Open camera': 'Mở máy ảnh',

  "Order with accessionNumber {{ accession_number }} already exists. Can't create a new order.":
    'Đã tồn tại dịch vụ với mã {{ accession_number }}. Không thể tạo mới',

  'No image available for Accession Number {{ accession_number }}!':
    'Mã chỉ định {{ accession_number }} chưa có hình ảnh sẵn sàng!',

  'Image not available': 'Hình ảnh chưa sẵn sàng',
  'The exam is currently unavailable': 'Dữ liệu ca chụp chưa sẵn sàng',
  'Please reload the page or try again after 24 hours. If you continue to have issues, contact the Vinmec Hotline for assistance.':
    'Vui lòng tải lại trang hoặc quay lại sau 24h nữa. Trường hợp vẫn không xem được hình ảnh, vui lòng liên hệ Hotline Vinmec để được hỗ trợ.',
  'Please reload the page or try again after 24 hours. If you continue to have issues, contact the Hotline for assistance.':
    'Vui lòng tải lại trang hoặc quay lại sau 24h nữa. Trường hợp vẫn không xem được hình ảnh, vui lòng liên hệ Hotline để được hỗ trợ.',
  'The image viewing period has expired': 'Đã hết hạn xem ca chụp',
  'Contact the Vinmec hotline for support, or download the MyVinmec app and connect your medical records to continue viewing the images.':
    'Liên hệ Hotline Vinmec để được hỗ trợ hoặc tải app MyVinmec và kết nối hồ sơ y tế để tiếp tục xem hình ảnh ca chụp.',
  'The image viewing link has expired. Please reopen the app to continue or contact the Vinmec Hotline for assistance.': 'Link xem hình ảnh đã hết hạn. Quý khách vui lòng truy cập lại ứng dụng để tiếp tục hoặc liên hệ Hotline Vinmec để được hỗ trợ.',
  'Contact the hotline for support.': 'Liên hệ Hotline để được hỗ trợ',
  'You no longer have access due to time limitation.':
    'Bạn không thể truy cập nội dung này do quá thời hạn cho phép.',

  'Are you sure want to close the camera while recording?':
    'Bạn có muốn tắt máy ảnh trong khi đang ghi hình không?',
  'Shutting off the camera while recording will cause you to lose the video you are capturing.':
    'Tắt máy ảnh trong khi ghi hình có thể làm mất video bạn đang ghi.',
  'Continue Recording': 'Tiếp tục ghi hình',
  'Select Department': 'Chọn khoa thực hiện',
  'Select Order Department': 'Chọn khoa chỉ định',
  'Select Body Part': 'Chọn bộ phận chụp',
  'No Report': 'Không có báo cáo',
  'This report is being modified by another user':
    'Báo cáo này đang được sửa đổi bởi người dùng khác',
  'This report is being modified by':
    'Báo cáo này đang được sửa đổi bởi người dùng',
  'Please select template to start editing report.':
    'Xin hãy lựa chọn mẫu để bắt đầu làm báo cáo.',
  'No report available': 'Không có báo cáo',
  'No order available': 'Không có chỉ định',
  'Choose Template': 'Lựa chọn mẫu',
  'Enter Scheduled Date': 'Nhập ngày chỉ định',
  'Your API key will appear here': 'API key sẽ hiển thị ở đây',
  'Patient Order List': 'Danh sách chỉ định',
  'Enter Device': 'Nhập tên thiết bị',
  'Select Match Status': 'Chọn trạng thái ghép',
  'Select Visit ID': 'Chọn mã lượt khám',
  'Enter Study Description': 'Nhập mô tả ca chụp',

  '{{ order_length }} order matched':
    '{{ order_length }} chỉ định đã được ghép',
  '{{ order_length }} orders matched':
    '{{ order_length }} chỉ định đã được ghép',
  '{{ order_length }} order unmatched':
    'Đã huỷ ghép {{ order_length }} chỉ định',
  '{{ order_length }} orders unmatched':
    'Đã huỷ ghép {{ order_length }} chỉ định',
  'Print Report': 'In báo cáo',
  Previous: 'Quay lại',
  'Import Data': 'Nhập dữ liệu',
  Images: 'Hình ảnh',
  'Print Layout': 'Mẫu bố cục in',
  'Powered by': 'Được cung cấp bởi',
  'Add New': 'Thêm mới',
  'View Study': 'Xem ca chụp',
  'Upload failed': 'Lỗi khi tải tệp lên',
  Success: 'Thành công',
  'Create Study successfully': 'Tạo ca chụp thành công',
  'Add New Study': 'Tạo ca chụp mới',
  'Open Studylist': 'Mở danh sách ca chụp',
  'Create Study': 'Tạo ca chụp',
  'Report saved successfully.': 'Lưu báo cáo thành công.',
  'Error occurred while saving the report. Please try again.':
    'Đã xảy ra lỗi khi lưu báo cáo. Vui lòng thử lại.',
  'Report approve successfully.': 'Phê duyệt báo cáo thành công.',
  'Error occurred while approving the report. Please try again.':
    'Đã xảy ra lỗi khi phê duyệt báo cáo. Vui lòng thử lại.',
  'Confirm Delete': 'Xác nhận xoá',
  'Are you sure you want to delete this item? This action cannot be undone.':
    'Bạn có chắc bạn muốn xóa tệp này? Hành động này không thể được hoàn tác.',
  'No matched study found': 'Không tìm thấy ca chụp phù hợp để ghép',
  'filter-management.Match': 'Đã thực hiện',
  'filter-management.Not Match': 'Chưa ghép chỉ định',
  "The report isn't ready yet": 'Báo cáo chưa sẵn sàng!',

  'Reset All Changes': 'Khôi phục tất cả thay đổi',
  'All unsaved changes will be removed.':
    'Tất cả các thay đổi chưa được lưu sẽ bị xóa.',
  'Proceed Anyway': 'Tiếp tục',
  'Go back': 'Quay lại',
  'Loading more...': 'Đang tải thêm...',
  'Shared By': 'Người chia sẻ',
  'Visited Date': 'Ngày khám',
  'Date of Birth': 'Ngày sinh',
  Notifications: 'Thông báo',

  Copy: 'Sao chép',
  'Link copied to clipboard.': 'Liên kết đã được sao chép.',
  'Copied to clipboard!': 'Đã sao chép vào bảng nhớ tạm!',
  "Couldn't copy. Please select the text and use Ctrl+C (Tap & hold on phone) to copy it manually.":
    'Không thể sao chép. Vui lòng chọn văn bản và sử dụng Ctrl+C (Nhấn và giữ trên điện thoại) để sao chép thủ công.',
  'Generate link first!': 'Xin hãy tạo liên kết trước!',
  'QR Code copied to clipboard.': 'QR Code đã được sao chép.',
  "Couldn't generate QR Code.": 'Không thể tạo QR Code.',
  'Password copied to clipboard.': 'Mật khẩu đã được sao chép.',
  'Description copied to clipboard.': 'Mô tả đã được sao chép.',
  'Copied to clipboard.': 'Nội dung đã được sao chép',
  'Copy Password': 'Sao chép mật khẩu',
  'Auto generate': 'Sinh tự động',
  'Copy Description': 'Sao chép mô tả',
  'Consultation link': 'Đường dẫn cuộc hội chẩn',

  'Modify Columns': 'Chỉnh sửa cột',
  'Order Doctor Name': 'Bác sĩ chỉ định',
  'Referring Physician': 'Bác sĩ tham chiếu',
  'Performing Physician': 'Bác sĩ thực hiện',
  'Study Status': 'Trạng thái ca chụp',
  Work: 'Công việc',
  'Find by Patient Name': 'Tìm theo tên bệnh nhân',
  Name: 'Tên',
  'Find by Patient ID': 'Tìm theo mã người bệnh',
  'Pull to refresh': 'Kéo để làm mới',
  MATCH: 'ĐÃ GHÉP',
  UNMATCH: 'CHƯA GHÉP',
  'Find by Institution Name': 'Tìm theo tên cơ sở',
  'From Date': 'Từ ngày',
  'To Date': 'Đến ngày',
  'Copy Link': 'Sao chép link',
  'Copy QR Code': 'Sao chép mã QR',
  'You are recording a video. Do you want to stop recording and upload the data?':
    'Bạn đang quay video. Có muốn dừng quay và tải lên dữ liệu không?',
  'Access Type': 'Phạm vi truy cập',
  'Update Order': 'Cập nhật chỉ định',
  'Add Element': 'Thêm Element',
  Tooltip: 'Chú thích',
  'Show / Hide': 'Hiện / Ẩn',
  Text: 'Mô tả',
  Code: 'Mã',
  'Enter code': 'Nhập mã',
  'Enter name': 'Nhập tên',
  'Enter Name': 'Nhập tên',
  Option: 'Tuỳ chọn',
  'Add Option': 'Thêm tuỳ chọn',
  'Enter option': 'Nhập tuỳ chọn',
  'Enter value': 'Nhập giá trị',
  'Enter tooltip': 'Nhập chú thích',
  'Free Text': 'Có thể nhập',
  Tag: 'Thẻ',
  Tags: 'Thẻ',
  'Enter tags': 'Nhập thẻ',
  'Enter ID': 'Nhập ID',
  Label: 'Mô tả',
  'Enter label': 'Nhập mô tả',
  'Default Value': 'Giá trị mặc định',
  'Enter Default Value': 'Nhập giá trị mặc định',
  'Show label': 'Hiện mô tả',
  'Can edit': 'Có thể sửa',
  'Template ID': 'Mã mẫu báo cáo',
  'Enter Template ID': 'Nhập mã mẫu báo cáo',
  'Show Label': 'Hiện mô tả',
  'Can Edit': 'Có thể sửa',
  'Add New Element': 'Thêm mới Element',
  'Edit Element': 'Cập nhật Element',
  'Template Structured Report': 'Mẫu báo cáo có cấu trúc',
  'Add Template Structured Report': 'Thêm mẫu báo cáo có cấu trúc',
  'Edit Template Structured Report': 'Cập nhật mẫu báo cáo có cấu trúc',
  'already exists': 'đã tồn tại',
  'Format Date': 'Định dạng ngày',
  'Format Time': 'Định dạng thời gian',
  'Clinical Information': 'Thông tin lâm sàng',
  Comparison: 'So sánh',
  Technique: 'Kỹ thuật',
  Findings: 'Mô tả',
  Impression: 'Chẩn đoán',
  'Scheduled At': 'Thời gian lên lịch',
  'Scheduled By': 'Người lên lịch',
  'Received At': 'Thời gian tiếp nhận',
  'Completed At': 'Thời gian hoàn thành',
  'Completed By': 'Người hoàn thành',
  'Approved At': 'Thời gian duyệt báo cáo',
  'Delivered At': 'Thời gian trả kết quả',
  'Tech Note': 'Tech Note',
  'Started At': 'Thời gian bắt đầu',
  'Suspended At': 'Thời gian tạm dừng',
  'Suspended By': 'Người tạm dừng',
  'Select Element': 'Lựa chọn Element',
  'New Note': 'Ghi chú mới',
  Insert: 'Nhập',
  'Select format date': 'Chọn định dạng ngày',
  'Select format time': 'Chọn định dạng thời gian',
  Schedule: 'Lập lịch',
  Continue: 'Tiếp tục',
  'Canceled At': 'Thời gian hủy',
  'Canceled By': 'Người hủy',
  'Received By': 'Người tiếp nhận',
  'Request Department': 'Khoa chỉ định',
  'Started By': 'Người bắt đầu',
  'Deliver Report': 'Trả kết quả',
  'Delivered By': 'Người trả kết quả',
  'Result Delivery Location': 'Địa điểm trả kết quả',
  'Schedule At': 'Thời gian lên lịch',
  'Schedule By': 'Người lên lịch',
  'Create At': 'Thời gian tạo',
  'Create By': 'Người tạo',
  'Arrive At': 'Thời gian đến',
  'Arrive By': 'Người đến',
  'Suspend At': 'Thời gian tạm dừng',
  'Suspend By': 'Người tạm dừng',
  'Reading At': 'Thời gian đọc',
  'Reading By': 'Người đọc',
  'Submit At': 'Thời gian gửi',
  'Submit By': 'Người gửi',
  'Approve At': 'Thời gian duyệt',
  'Approve By': 'Người duyệt',
  'Cancel At': 'Thời gian hủy',
  'Cancel By': 'Người hủy',
  'Start At': 'Thời gian bắt đầu',
  'Start By': 'Người bắt đầu',
  Complete: 'Hoàn thành',
  Suspend: 'Tạm dừng',
  'You do not have permission to edit.': 'Bạn không có quyền chỉnh sửa.',
  'Complete At': 'Thời gian hoàn thành',
  'Complete By': 'Người hoàn thành',
  'Select status': 'Chọn trạng thái',
  'Select priority': 'Chọn mức độ ưu tiên',
  'Status mismatch, please choose the same status.':
    'Trạng thái không phù hợp, vui lòng chọn cùng trạng thái chỉ định.',
  'Modality mismatch, please choose the same modality.': 'Loại thiết bị không phù hợp, vui lòng chọn chỉ định cùng loại thiết bị.',
  'Detail label': 'Mô tả chi tiết',
  'Detail value': 'Giá trị chi tiết',
  'Enter Detail Label': 'Nhập mô tả chi tiết',
  'Enter Detail Value': 'Nhập giá trị chi tiết',
  'Please enter a number between 0 and 99': 'Vui lòng nhập số từ 0 đến 99',

  'Manual edit': 'Chỉnh sửa thủ công',
  Width: 'Độ rộng',
  Height: 'Độ cao',
  'Width (px)': 'Độ rộng (px)',
  'Height (px)': 'Độ cao (px)',
  'Enter Width': 'Nhập chiều rộng',
  'Enter Height': 'Nhập chiều cao',
  'Edit image size': 'Chỉnh sửa kích thước ảnh',
  'Edit image': 'Chỉnh sửa ảnh',
  'Align left': 'Căn trái',
  'Align right': 'Căn phải',
  'Align top': 'Căn trên',
  'Align bottom': 'Căn dưới',
  'Align center': 'Căn giữa',
  'Center vertically': 'Căn giữa theo chiều dọc',
  Vertical: 'Chỉnh dọc',
  Horizontal: 'Chỉnh ngang',
  'Add image': 'Thêm ảnh',
  'Select a date and time': 'Chọn ngày và giờ',
  'Select a date': 'Chọn ngày cụ thể',
  'Select a time': 'Chọn giờ cụ thể',
  'Input details': 'Nhập thông tin',
  'Select an option': 'Chọn một tùy chọn',
  'Provide a quantity': 'Nhập số lượng',

  Monitoring: 'Giám sát',
  'Digital Sign': 'Ký số',
  'Digital Sign Management': 'Quản lý ký số',
  'Reason of Failure': 'Nguyên nhân lỗi',
  'Executed At': 'Thời gian thực hiện',
  Consultation: 'Hội chẩn',
  'Consultation Management': 'Quản lý hội chẩn',
  Title: 'Tiêu đề',
  'Enter Title': 'Nhập tiêu đề',

  CONTENT: 'NỘI DUNG',
  CONCLUSION: 'KẾT LUẬN',
  'Unable to load image': 'Đang gặp sự cố khi tải hình ảnh',
  'No image uploaded yet': 'Chưa có hình ảnh được tải lên',

  Remove: 'Xóa',
  Update: 'Cập nhật',
  Bidirectional: 'Thước đo hai chiều',
  ArrowAnnotate: 'Chú thích mũi tên',
  Angle: 'Đo góc',
  CobbAngle: 'Đo góc Cobb',
  PlanarFreehandROI: 'Vẽ tự do',
  Polyline: 'Vẽ nhiều đoạn',
  Probe: 'Điểm ảnh',
  Rectangle: 'Hình chữ nhật',
  RectangleROI: 'Hình chữ nhật',
  EllipticalROI: 'Hình elip',
  CircleROI: 'Hình tròn',
  CTRatio: 'Đo tỉ lệ tim ngực',
  HeartRate: 'Đo nhịp tim',
  QTPoint: 'Đo khoảng QT',
  'Window Level changed': 'Thay đổi cửa sổ ảnh',
  'Layout changed': 'Thay đổi bố cục',
  'Camera changed': 'Thay đổi góc độ ảnh',
  'Series changed': 'Thay đổi series',
  Scroll: 'Cuộn',
  Invert: 'Đảo ngược màu',
  'Active viewport changed': 'Thay đổi kích hoạt khung xem',
  'Protocol changed': 'Thay đổi giao thức xem',
  'Viewport sync state changed': 'Thay đổi trạng thái đồng bộ',
  'Reference line state changed': 'Thay đổi trạng thái đương tham chiếu',
  'Crosshairs changed': 'Thay đổi vị trí tương quan',
  'Toggle crosshairs': 'Bật tắt vị trí tương quan',
  'MPR reset': 'Đặt lại MPR',
  'Clear Annotations': 'Xóa toàn bộ thước đo',
  'Slab thickness changed': 'Thay đổi độ dày lát cắt',
  'Blend mode changed': 'Thay đổi chế độ hòa trộn',
  '3D camera changed': 'Thay đổi góc độ 3D',
  '3D window level changed': 'Thay đổi cửa sổ ảnh 3D',
  '3D properties changed': 'Thay đổi thông số 3D',
  '3D preset changed': 'Thay đổi đặt trước 3D',
  '3D length': 'Thước đo 3D',
  '3D length updated': 'Cập nhật thước đo 3D',
  '3D reset': 'Đặt lại 3D',
  '3D remove bed': 'Xóa giường',
  '3D scalpel': 'Cắt gọt',
  'Load study metadata': 'Tải dữ liệu ca chụp',
  'Toggle patient information': 'Bật tắt thông tin bệnh nhân',

  'Init consultation': 'Khởi tạo cuộc hội chẩn',
  Host: 'Chủ trì',
  'Stop Host': 'Dừng chủ trì',
  Join: 'Tham gia',
  Disconnect: 'Ngắt kết nối',
  'Connection started': 'Đã kết nối',
  'Connection closed': 'Đã ngắt kết nối',
  'Connection error': 'Lỗi kết nối',
  'Room not found': 'Không tìm thấy phiên hội chẩn',
  'User not found': 'Người dùng không khả dụng',
  'Reset Viewer': 'Đặt lại Viewer',
  'Are you sure reset viewer before start?':
    'Bạn có chắc muốn đặt lại Viewer trước khi bắt đầu?',

  'Message Type': 'Loại bản tin',
  'Enter Message Type': 'Nhập loại bản tin',
  'Processing ID': 'Mã xử lý',
  'Enter Processing ID': 'Nhập mã xử lý',
  'Sending Application': 'Ứng dụng gửi',
  'Enter Sending Application': 'Nhập ứng dụng gửi',
  'Receiving Application': 'Ứng dụng nhận',
  'Enter Receiving Application': 'Nhập ứng dụng nhận',
  Failed: 'Thất bại',
  'Study ID': 'Mã ca chụp',
  'Study UID': 'UID ca chụp',
  'Patient Phone': 'SĐT người bệnh',
  'HL7 Management': 'Quản lý HL7',
  Waiting: 'Đang xử lý',
  Resend: 'Gửi lại',
  'Default Institution': 'Cơ sở mặc định',
  'Esign Code': 'Mã ký số',
  'Esign Role': 'Vai trò ký số',
  Revoke: 'Thu hồi',
  'Enter Order ID': 'Nhập Order ID',
  Unsigned: 'Chưa ký',
  Signed: 'Đã ký',
  Revoking: 'Chờ thu hồi',
  'Revoke Failed': 'Thu hồi lỗi',
  Revoked: 'Đã thu hồi',
  'Approver Signed': 'Người duyệt đã ký',
  'Approver Failed': 'Người duyệt ký lỗi',
  'Submitter Signed': 'Người đọc đã ký',
  'Submitter Failed': 'Người đọc ký lỗi',
  'ESIGN.Waiting': 'Chờ ký',
  'Number of Retries': 'Số lần thử lại',
  'Select Default Institution': 'Chọn cơ sở mặc định',
  'Enter Esign Code': 'Nhập mã ký số',
  'Enter Esign Role': 'Nhập vai trò ký số',
  'Wait Time': 'Thời gian chờ',
  'Total Time': 'Tổng thời gian',
  'E-sign': 'Ký số',
  'Sign Report': 'Ký báo cáo',
  'Enter Your Password': 'Nhập mật khẩu',
  'Please input password': 'Vui lòng nhập mật khẩu',
  'The current E-Sign status of {{esign_status}} is invalid. Please ensure the status is one of the following Pending, Approved, Signed.':
    'Trạng thái Chữ ký điện tử hiện tại {{esign_status}} không hợp lệ. Vui lòng đảm bảo trạng thái của chữ ký là Đang chờ xử lý, Đã phê duyệt, Đã ký.',
  'This report needs to be approved first.':
    'Báo cáo này cần phải được phê duyệt trước.',
  'Only approver can sign this report.':
    'Chỉ người phê duyệt mới có thể ký vào báo cáo này.',
  'Resend successfully!': 'Gửi lại thành công!',
  'Please only resend with status that are APPROVER FAILED, SUBMITTER FAILED, or REVOKE FAILED.':
    'Vui lòng chỉ gửi lại với trạng thái NGƯỜI DUYỆT KÝ LỖI, NGƯỜI ĐỌC KÝ LỖI hoặc THU HỒI LỖI.',
  'Report Indicator': 'Trạng thái chẩn đoán',
  'Select Report Indicator': 'Chọn trạng thái chẩn đoán',
  'Assign To': 'Phân công',
  'Select Assign To': 'Chọn phân công',
  'Please only resend with status that are Success, Failed.':
    'Vui lòng chỉ gửi lại với trạng thái Thành Công hoặc Thất bại.',
  'Unable to revoke. Please try again later.':
    'Không thể thu hồi. Vui lòng thử lại sau.',
  'Unable to resend. Please try again later.':
    'Không thể gửi lại. Vui lòng thử lại sau.',
  'An unexpected error occurred.': 'Đã xảy ra lỗi không mong muốn.',
  'Revoke successfully!': 'Thu hồi thành công!',
  Indicator_Normal: 'Bình thường',
  Unspecified: 'Không xác định',
  'Report URL is missing': 'URL báo cáo bị thiếu',
  'Please select the final version of the report to use this feature.':
    'Vui lòng chọn phiên bản cuối cùng của báo cáo để sử dụng tính năng này.',
  'The report is signed, it becomes legally binding. If you need to modify it, you must first revoke the signature.':
    'Báo cáo hiện đã được ký, lúc này nó mang tính chất pháp lý. Nếu cần thay đổi thông tin, bạn phải hủy bỏ chữ ký trước tiên.',
  'Select Esign Status': 'Chọn trạng thái ký',
  'Esign Status': 'Trạng thái ký',

  'New version': 'Phiên bản mới',
  available: 'khả dụng',
  'Do you want to download?': 'Bạn có muốn tải xuống?',
  'View file PDF': 'Xem tệp PDF',
  'This report is pending a digital signature. Please wait...':
    'Báo cáo này đang được ký số. Vui lòng chờ...',
  Compare: 'So sánh',
  'Close Compare': 'Đóng so sánh',

  'Add Consultation': 'Thêm cuộc hội chẩn',
  'Edit Consultation': 'Cập nhật cuộc hội chẩn',
  'Enter Description': 'Nhập mô tả',
  Link: 'Đường dẫn',
  'User lacks the permission report.print to print reports.':
    'Người dùng thiếu quyền report.print để in báo cáo.',
  'The report is not approved.': 'Báo cáo chưa được phê duyệt.',
  'The report is not the latest version.':
    'Báo cáo không phải là phiên bản mới nhất.',
  'PDF report is not available.': 'Báo cáo PDF không có sẵn.',
  'Can not find studies': 'Không tìm thấy ca chụp',

  Annotations: 'Đánh dấu',
  Cystic: 'Nang',
  Solid: 'Khối đặc',
  'Mixed cystic and solid': 'Hỗn hợp đặc và nang',
  'Hypoechoic region': 'Đám giảm âm',
  'Intraductal mass': 'Tổn thương nội ống',
  'Nonmass enhancement': 'Không tạo khối',
  'Lymph node': 'Hạch',
  Arrow: 'Mũi tên',
  'Remove selected annotation': 'Xóa đánh dấu đã chọn',
  'Clear all annotations': 'Xóa tất cả đánh dấu',
  'Add default image': 'Thêm ảnh mặc định',
  'Content is empty.': 'Không có nội dung.',
  'This report has been digitally signed. Please revoke the signature to edit the report':
    'Báo cáo này đã được ký số. Vui lòng thu hồi chữ ký để chỉnh sửa báo cáo ',
  'E-sign (Submitter)': 'E-sign (Người đọc)',
  'E-sign (Approver)': 'E-sign (Người duyệt)',
  'Only Approver can sign this report.': 'Chỉ người duyệt có quyền ký.',
  'Only Submitter can sign this report.': 'Chỉ người đọc có quyền ký.',
  'Order Institution Templates': 'Mẫu theo cơ sở',
  'Template data not found': 'Không tìm thấy dữ liệu mẫu báo cáo',
  'Order selection error. Please re-select from the list.':
    'Lỗi khi chọn chỉ định. Vui lòng chọn lại từ danh sách.',
  None: 'Không có',
  'QMS Name': 'Tên QMS',
  'QMS Type': 'Kiểu QMS',
  'Working Time': 'Thời gian làm việc',
  Morning: 'Buổi sáng',
  Afternoon: 'Buổi chiều',
  Doctor: 'Bác sĩ',

  Result: 'Kết quả',
  'Normal Range': 'Tham chiếu',
  Unit: 'Đơn vị',

  'Edit QMS': 'Cập nhật QMS',
  'Add QMS': 'Thêm QMS',
  'Device QMS': 'QMS thiết bị',
  'Linked Device QMS': 'Liên kết QMS thiết bị',
  'OVERVIEW': 'TỔNG QUAN',
  'DEVICE': 'THIẾT BỊ',
  'Are you sure you want to delete the QMS?': 'Bạn có chắc chắn muốn xóa QMS này?',
  'QMS Management': 'Quản lý QMS',
  'Enter QMS Name': 'Nhập tên QMS',
  'Select QMS Type': 'Chọn loại QMS',
  'Arrived Time': 'Tiếp nhận',
  'QMS.Waiting': 'Chờ thực hiện',
  'QMS.In Progress': 'Đang thực hiện',
  'QMS.Start': 'Thực hiện',
  'QMS.Miss Call': 'Gọi nhỡ',
  'QMS.Done': 'Hoàn thành',
  'QMS.Urgent': 'Khẩn cấp',
  'QMS.High': 'Cao',
  'QMS.Normal': 'Thường',
  'Receive QMS': 'Tiếp nhận QMS',
  'No available QMS': 'Không có QMS khả dụng',
  'No available Device': 'Không có thiết bị khả dụng',
  'Default Order QMS': 'QMS Chỉ định mặc định',
  'Default Worklist QMS': 'QMS Danh sách công việc mặc định',
  'Open in New Tab': 'Mở trong tab mới',
  'QMS Profile': 'Thông tin QMS',
  'Please select default worklist QMS': 'Vui lòng chọn QMS Danh sách công việc mặc định',
  'Please select default order QMS': 'Vui lòng chọn QMS Chỉ định mặc định',
  'The QMS profile has been updated.': 'Thông tin QMS đã được cập nhật.',
  'Please select QMS': 'Vui lòng chọn QMS',

  'Category': 'Danh mục',
  'Windows': 'Windows',
  'Popup': 'Popup',
  'Missed Call': 'Gọi nhỡ',
  'Waiting List': 'Danh sách chờ',
  'Enter time': 'Nhập thời gian',
  'Waiting Time': 'Thời gian chờ',
  'In Process': 'Đang thực hiện',
  'Miss Call': 'Gọi nhỡ',
  'Done': 'Hoàn thành',
  'No linked QMS': 'Không có QMS liên kết',
  'The QMS configuration has already been used': 'Cấu hình QMS đã được sử dụng',

  'Time.m': 'p',

  'Type your note here': 'Nhập ghi chú',
  'Delete note': 'Xóa ghi chú',
  'Are you sure you want to delete this note?': 'Bạn có chắc chắn muốn xóa ghi chú này?',
  'Request Host': 'Yêu cầu điều khiển',
  'Connect': 'Kết nối',
  'View Image': 'Xem ảnh',
  'Detail': 'Chi tiết',
  'Consultation Detail': 'Chi tiết hội chẩn',
  'edited at': 'cập nhật lúc',
  'Cannot Connect. The consultation is not in \'Scheduled\' status.': 'Không thể kết nối. Cuộc hội chẩn không trong trạng thái \'Đã lên lịch\'.',
  'Cancel Consultation': 'Hủy cuộc hội chẩn',
  'Complete Consultation': 'Hoàn thành cuộc hội chẩn',
  'The consultation has been completed.': 'Cuộc hội chẩn đã hoàn thành.',
  'Are you sure you want to complete this consultation?': 'Bạn có chắc chắn muốn hoàn thành cuộc hội chẩn này?',
  'request to be host': 'yêu cầu quyền điều khiển',
  'Are you sure to accept this request?': 'Bạn có chắc chắn muốn chấp nhận yêu cầu này?',
  'Syncing annotations from server to client': 'Đang đồng bộ lại các chú thích từ máy chủ',
  'Syncing viewer state from server to client': 'Đang đồng bộ lại trạng thái xem từ máy chủ',
  'Duplicate email. Please enter a unique email.': 'Email đã tồn tại. Vui lòng nhập email khác.'
};
